import "array.prototype.at/auto";
import "string.prototype.at/auto";
import { createRoot } from "react-dom/client";
import { buildDefaultFormSchema } from "../../components/common/BuyButton/v2/models/defaultFormSchema";
import { FormSchema } from "../../components/common/BuyButton/v2/models/formSchema";
import { standardTheme } from "../../components/common/BuyButton/v2/themes/standard";
import { BuyButtonThemeProvider } from "../../components/common/BuyButton/v2/themes/ThemeContext";
import { Tracking } from "../../components/common/Tracking";
import { registerReplaceForm } from "../../libs/client/replaceForm";
import { BuyButton } from "./BuyButton/v2/BuyButton";
import "../../globals.css";

type Props = {
  store: "survaq" | "calqs";
  productId: string | null;
  productTitle: string | null;
  formSchema: string | null;
  /** フォームが無いとき、代表商品のバリエーションを選ぶ既定のフォームを出すか (SatellitePage が決める) */
  useDefaultForm: boolean;
};

const rawJson = document.getElementById("__PROPS__")?.textContent;
const props: Props | null = rawJson ? JSON.parse(rawJson) : null;

const rootNode = document.getElementById("root");
const buyButtonNode = document.getElementById("buy-button");

if (rootNode && props) {
  createRoot(rootNode).render(<Tracking />);

  const buyButtonRoot = buyButtonNode ? createRoot(buyButtonNode) : null;

  // サテライトLP (survaq/calqs 共通) は SurvaQ ストア本体と同じ標準テーマを使う。
  const renderForm = (formSchema: FormSchema) => {
    buyButtonRoot?.render(
      <BuyButtonThemeProvider theme={standardTheme}>
        <BuyButton
          store={props.store}
          formSchema={formSchema}
          productId={props.productId}
          productTitle={props.productTitle}
        />
      </BuyButtonThemeProvider>,
    );
  };

  if (props.formSchema) {
    renderForm(JSON.parse(props.formSchema));
  } else if (props.useDefaultForm && props.productId) {
    renderForm(buildDefaultFormSchema(props.productId));
  }

  registerReplaceForm(props.store, renderForm);
}
